import { render, staticRenderFns } from "./SettingsApp.vue?vue&type=template&id=02c6e0e9"
import script from "./SettingsApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsApp.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports